import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: "/app-shipper",
  children: [
    {
      path: "app-download",
      name: "shipper-app-download",
      // redirect: "/app-driver/app-download",
      component: () => import('@/views/app-shipper/index.vue'),
      meta: {
        title: "佬司机",
      },
    },
	{
	  path: "supply-sharing",
	  name: "shipper-supply-sharing",
	  component: () => import('@/views/app-shipper/supply-sharing/index.vue'),
	  meta: {
	    title: "货源转发",
	  },
	},
    {
      path: "pre-upgrade/:versionId",
      name: "shipper-app-pre-upgrade",
      component: () => import('@/views/app-shipper/pre-upgrade/index.vue'),
      props: true,
      meta: {
        title: "佬司机预更新介绍",
      },
    },
    {
      path: "/app-shipper/:path(.*)*",
      redirect: "/app-driver/app-download"
    }
  ],
};

export default routes;
